import { render, staticRenderFns } from "./iTable.vue?vue&type=template&id=78793d9f"
import script from "./iTable.vue?vue&type=script&lang=js"
export * from "./iTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports